import React from "react";

interface TableCellProps {
  children: React.ReactNode;
  hasTooltip?: boolean;
  tooltipDirection?: string;
}

export const TableCell: React.FC<TableCellProps> = ({ children, hasTooltip, tooltipDirection }) => {
  return (
    <div className={`table-inner-item ${(children || children !== "-") && hasTooltip ? "has-tooltip" : ""}`}>
      {children || "-"}
      {
        (children && hasTooltip) && (
          <div className={`tooltip-wrp ${tooltipDirection || ""}`}>
            <div className="tooltip-wrp-inner">
              {children}
            </div>
          </div>
        )
      }
    </div>
  )
};
